import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TokenDecode } from '../../utils/general-util';
import type { PageSettingsState } from './types.ts';
import type { DecodedUserInfo } from '@shared/types/user.ts';

export const loadPageSettingsFeatures = createAsyncThunk<DecodedUserInfo | null>(
  'loadPageSettingsFeatures',
  TokenDecode,
);

const initState: PageSettingsState = { features: {} };

const pageSettingsSlice = createSlice({
  name: 'pageSettings',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        'loadPageSettingsFeatures/fulfilled',
        (state: PageSettingsState, action: { payload: DecodedUserInfo | null }) => {
          if (action.payload?.Features) {
            state.features = action.payload.Features.reduce(
              (acc, { feature_id, ...rest }) => {
                acc[feature_id] = rest;
                return acc;
              },
              {} as PageSettingsState['features'],
            );
          } else {
            state.features = {};
          }
          state.featuresLoaded = true;
        },
      )
      .addCase('loadPageSettingsFeatures/rejected', (state: PageSettingsState) => {
        state.featuresLoaded = true;
      });
  },
});

export default pageSettingsSlice.reducer;
